import React from 'react';
import { motion } from 'framer-motion';
import { TRUST_IMAGES } from '../data/site';
import { useLanguage } from '../data/i18n';
import { Divider } from './Divider';
export function Trust() {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full bg-black py-24 sm:py-32" data-id="element-209" data-mp="1t1oexijf9x70">
      <div className="mx-auto max-w-6xl px-6 text-center" data-id="element-210" data-mp="1o8ve35r2r907">
        <p className="font-sans text-[10px] uppercase tracking-[0.4em] text-ash" data-id="element-211" data-mp="1o7k76x2c1l4v">{t.trust.eyebrow}</p>

        <div className="mt-12 grid gap-4 sm:grid-cols-3" data-id="element-212" data-mp="222mn8d0w8qve">
          {TRUST_IMAGES.map((src, i) => <motion.div key={src} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7,
          delay: i * 0.12,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative aspect-[4/5] sm:aspect-[3/4] w-full overflow-hidden ring-1 ring-white/15" data-id="element-213" data-mp="1x431acmavf31" data-mpi={i}>
              <img src={src} alt={t.trust.imageAlt} className="h-full w-full scale-[1.15] object-cover object-center grayscale contrast-125 transition-all duration-500 hover:grayscale-0" data-id="element-214" data-mp="3uczav1qyoo7l" />
            </motion.div>)}
        </div>

        <div className="mt-14" data-id="element-215" data-mp="bygawpp35k86">
          <Divider data-id="element-216" data-mp="bzrnnf0ie2bf" />
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.7
        }} className="mx-auto mt-8 max-w-3xl font-display text-3xl sm:text-5xl leading-[1.05] tracking-[0.06em] text-bone" data-id="element-217" data-mp="c0azqf3h9whj">
            {t.trust.headline}
          </motion.p>
        </div>
      </div>
    </section>;
}